var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "voice-configuration" },
    [
      _c(
        "div",
        { staticClass: "voice-button-group" },
        [
          _c(
            "div",
            {
              staticClass: "voice-selector-btn",
              on: { click: _vm.openVoiceSelector },
            },
            [
              _c("div", { staticClass: "btn-content" }, [
                _c("div", { staticClass: "voice-info" }, [
                  _c("i", { staticClass: "material-icons voice-icon" }, [
                    _vm._v("music_note"),
                  ]),
                  _vm._v(" "),
                  _vm.selectedVoice
                    ? _c("div", { staticClass: "voice-name" }, [
                        _vm._v(_vm._s(_vm.selectedVoice.voice_name)),
                      ])
                    : _c("div", { staticClass: "voice-name" }, [
                        _vm._v(_vm._s(_vm.$t("voiceagent.selectVoice"))),
                      ]),
                ]),
                _vm._v(" "),
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("expand_more"),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "a-popover",
            {
              attrs: {
                placement: "topLeft",
                visible: _vm.isSettingsVisible,
                trigger: ["click"],
                overlayClassName: "voice-settings-popover",
              },
              on: { visibleChange: _vm.handleSettingsVisibleChange },
            },
            [
              _c(
                "template",
                { slot: "content" },
                [
                  _c("VoiceSettings", {
                    attrs: {
                      voiceModel: _vm.voiceModel,
                      voiceTemperature: _vm.voiceTemperature,
                      voiceSpeed: _vm.voiceSpeed,
                      voiceVolume: _vm.voiceVolume,
                    },
                    on: {
                      update: _vm.handleSettingsUpdate,
                      close: function ($event) {
                        _vm.isSettingsVisible = false
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "voice-settings-btn" }, [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("settings"),
                ]),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isVoiceSelectorVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                title: "Ses Seçimi",
                showFooter: false,
                className: "voice-selector-modal",
                large: "",
              },
              on: {
                cancel: function ($event) {
                  _vm.isVoiceSelectorVisible = false
                },
              },
            },
            [
              _c("VoiceSelector", {
                attrs: { selectedVoice: _vm.selectedVoice },
                on: { select: _vm.handleVoiceSelect },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }